import type { WebhookInvocationDto } from "../../services/ApiService";
import type { WebhookInvocation } from "../../types/Webhook";
import { isNil } from "lodash-es";
import EventId from "../../state/EventId";

const toStatus = (status: string): WebhookInvocation["status"] => {
  switch (status) {
    case "SUCCESS":
      return "SUCCESS";
    case "FAILED":
      return "FAILED";
    default:
      return "UNKNOWN";
  }
};

export const toWebhookInvocation = (dto: WebhookInvocationDto): WebhookInvocation => ({
  eventId: EventId.from(dto.eventId),
  type: dto.type,
  status: toStatus(dto.status),
  httpStatusCode: dto.statusCode,
  message: dto.message,
  invokedOn: new Date(dto.invokedOn),
  retryOn: isNil(dto.retryOn) ? undefined : new Date(dto.retryOn),
});
